import { Orbit } from 'lucide-react';
import { SplineSceneBasic } from '../components/ui/spline-demo';

export function MissionPage() {
  return (
    <section
      id="mission"
      className="min-h-screen scroll-mt-24 bg-neutral-950 pb-16 pt-32 text-neutral-100 md:pb-20 md:pt-36"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 px-4 md:px-8">
        <header className="space-y-3">
          <p className="inline-flex items-center gap-2 rounded-full border border-white/20 px-3 py-1 text-xs uppercase tracking-[0.22em] text-white">
            <Orbit className="h-4 w-4" />
            Valinor Dynamics
          </p>
          <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">
            Dual-tech systems for cameras, autonomous ground vehicles, and mission awareness
          </h1>
          <p className="max-w-3xl text-white">
            We build camera systems and autonomous ground vehicle platforms that help safety,
            security, and defense teams detect, monitor, and respond faster in complex environments.
          </p>
        </header>

        <SplineSceneBasic />
      </div>
    </section>
  );
}
